module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget widget-user-2"
  }, [_c('div', {
    staticClass: "widget-user-header bg-yellow"
  }, [_c('div', {
    staticClass: "widget-user-image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.profileImage,
      "alt": "User Avatar"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "widget-user-username"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('h5', {
    staticClass: "widget-user-desc"
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-stacked"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(item.name) + " "), _c('span', {
      staticClass: "pull-right badge",
      class: item.badge.theme
    }, [_vm._v(_vm._s(item.badge.count))])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-024ef9ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VASocialUser.v2.vue
// module id = 488
// module chunks = 1